// @flow

import * as React from 'react';
import PropTypes from 'prop-types';

import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';

const Item = ({
  item: { column, visible },
  disabled = false,
  onToggle = () => {},
  ...restProps
}) => (
  <ListItem disablePadding {...restProps}>
    <ListItemButton disabled={disabled} onClick={!disabled ? onToggle : null}>
      <Checkbox
        checked={visible}
        tabIndex={-1}
        disableRipple
        disabled={disabled}
        style={{ width: 'auto', height: 'auto' }}
      />
      <ListItemText primary={column.label || column.id} />
    </ListItemButton>
  </ListItem>
);

Item.propTypes = {
  item: PropTypes.shape({
    column: PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string
    }),
    visible: PropTypes.bool
  }).isRequired,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func
};

export default Item;